export default "__VITE_ASSET__DVgojfO8__"